import { axios } from '@/services/axios';

export const createTRSCluster = (clusterData) => {
    const res = axios.post('/TRSCluster/', clusterData);
    return res;
};
